import i18nRouteMeta from '@/app-core/mixins/i18n/i18nRouteMeta'
import AddressCommon from '@/app-core/mixins/maps/addressCommon'
import VMap from '@/app-theme/components/map/VMap.vue'
import AccountAddEditAddressDialog from '@/app-theme/components/account/AccountAddEditAddressDialog.vue'
import CustomerModel from '@/app-core/api/models/customer/CustomerModel'
import API from '@/app-core/api/Api'

export default {
  name      : 'AccountAddresses',
  components: {AccountAddEditAddressDialog, VMap},
  directives: {},
  mixins    : [i18nRouteMeta, AddressCommon],
  props     : {},
  enums     : {},
  dataStore : {},
  data() {
    return {
      isFormSaving               : false,
      addEditAddressDialogVisible: false,
      selectedAccountAddress     : null
    }
  },
  computed: {},
  watch   : {},
  beforeCreate() {
  },
  created() {
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {
    addAddress() {
      this.selectedAccountAddress = null
      this.addEditAddressDialogVisible = true
    },

    editAddress(address) {
      if (!address) return

      this.selectedAccountAddress = address
      this.addEditAddressDialogVisible = true
    },

    onAddressSaveSuccess(data) {
      if (!data?.CustomerInfo) return
      this.user = new CustomerModel(data.CustomerInfo)
    },


    async deleteAddress(address) {
      this.$root.$confirm.open(
        this.$t('Account.Addresses.Notification.Delete.Title'),
        '',
        this.$t('Account.Addresses.Notification.Delete.Body'),
        {
          color        : 'red',
          icon         : 'mdi-alert',
          coloredBorder: false,
          dark         : true,
          button       : {
            no : {title: this.$t('Common.Button.Cancel')},
            yes: {title: this.$t('Common.Button.Ok')}
          }
        }
      ).then(response => {
        if (response) this.onConfirmDelete(address)
      })
    },

    async onConfirmDelete(address) {
      if (!address) return

      this.selectedAccountAddress = address
      this.$set(address, 'isDeleting', true)

      try {
        const response = await address.Delete()
        this.handleDeleteResponse(response)
      } catch (error) {
        this.handleDeleteResponse(error.response)
      }

      this.$set(address, 'isDeleting', false)
    },

    handleDeleteResponse(response) {
      const data = API.responseData(response) || {}
      const message = data?.Messages

      if (API.isResponseSuccess(response) && data?.CustomerInfo) {
        this.user = new CustomerModel(data.CustomerInfo)

        this.$bus.$emit('app:show-notification', {
          body   : message?.Success || this.$t('Common.Message.DeleteSuccess.Title'),
          type   : 'success',
          icon   : 'mdi-check-circle',
          timeout: 5000
        })
      } else {
        this.$bus.$emit('app:show-notification', {
          body   : this.$t('Common.Error.Generic'),
          type   : 'error',
          icon   : 'mdi-alert',
          timeout: 5000
        })
      }
    }
  }
}
